import React, { useState } from "react";
import styled from "styled-components";

const Root = styled.div``;
const Container = styled.div`
  position: relative;
`;

const SelecteWrapper = styled.div`
  display: flex;
`;
const Select = styled.select`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 10px;
  border: none;
  margin: 0 10px;
  outline: none;
  cursor: pointer;
  @media (max-width: 1440px) {
    padding: 12px 8px;
  }
`;
const Option = styled.option`
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 28px;
  background-color: #262A2D;
    color: white;
    cursor: pointer !important;
  :hover {
    padding: 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
`;

const FilterShotContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const FliterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const FilterSelect = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 10px;
  border: none;
  margin: 0 10px;
  outline: none;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  margin: 0 10px;
`;
const Image = styled.img``;
const DropDownSection = styled.div`
  background: #191919;
  border-radius: 8px;
  position: absolute;
  z-index: 999;
  left: 65%;
  border-radius: 10px;
  width: 45%;
  top: 120%;
`;
const ListWrapper = styled.div`
  background-color: #191919;
  border-radius: 15px;
  display: flex;
  justify-content: flex-start;
  padding: 15px 20px;
  /* margin: 15px 20px; */
  width: 100%;
`;
const List = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
`;

const StyledSelect = styled.select`
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f7f7f7;
  color: #333;
  outline: none;
  @media(max-width:1024px){
  width: 100%;
}
`;



const CategoriesFilter = ({selectFilter, setSelectFilter}) => {
  const [category, setCategory] = useState("All");
  const [subcategory, setSubcategory] = useState("All");
  const [type, setType] = useState("All");
  const [subcategories, setSubcategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [filterState, setFilterState] = useState("");
  

  const changeCategory = (e) => {
    setCategory(e.target.value);
    setSubcategories(
      Categories.find((cat) => cat.name === e.target.value).subcategories
    );
  };

  const changeSubCat = (e) => {
    setSubcategory(e.target.value);
    setTypes(
      subcategories.find((subcategory) => subcategory.name === e.target.value)
        .types
    );
    // console.log(".......", subcategories);
  };


  return (
    <Root>
      <Container>
      <StyledSelect 
      onChange={(e)=>{
        setSelectFilter(e.target.value)
      }}
      >
      <Option value="All">ALL</Option>
      <Option value="phtl">Price High to Low</Option>
      <Option value="plth">Price Low to High</Option>
      <Option value="latest">Latest</Option>
    </StyledSelect>
      </Container>
    </Root>
  );
};

export default CategoriesFilter;
